<template>
  <div
    class="d-flex flex-column justify-space-between"
    style="min-height: calc(100vh - 137px);"
  >
    <div style="height: 1px;"></div>

    <v-row>
      <!-- Article -->
      <v-col
        cols="12"
        md="6"
        align-self="center"
        class="white--text"
      >
        <h1>
          Global Coach Group Webinar
        </h1>

        <p>
          Join us in this upcoming webinar,
          where we will discuss the future of the Global Coach Group.
        </p>

        <p>
          The webinar will begin at 9:00 AM BST (London).
        </p>

        <p>
          See below to view in your timezone:
        </p>

        <ul>
          <li>12:00 PM (Dubai)</li>
          <li>13:30 PM (Mumbai)</li>
          <li>16:00 PM (Hong Kong)</li>
          <li>18:00 PM (Sydney)</li>
          <li>9 AM BST (London)</li>
          <li>
            <a
              class="white--text"
              href="https://www.timeanddate.com/worldclock/fixedtime.html?msg=Global+Coach+Group+Webinar&amp;iso=20200903T09&amp;p1=136&amp;ah=1"
              target="_blank"
              rel="noopener"
            >
              <u>Click here to view the meeting time in your local time</u>
            </a>
          </li>
        </ul>
      </v-col>

      <!-- Sign up card -->
      <v-col
        cols="12"
        md="6"
        align-self="center"
      >
        <v-card light>
          <v-card-title>
            Register here
          </v-card-title>
          <v-card-text>
            <!-- Whole form -->
            <span
              class="demio-embed-registration"
              data-hash="UXlNlLI5tbIcj349"
              data-api="api/v1"
              data-base-uri="https://my.demio.com/"
              data-form-width="100%"
              data-color="#003865"
              data-text="REGISTER NOW"
            ></span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <div style="height: 1px;"></div>
  </div>
</template>

<script>
export default {
  name: 'WebinarSignUp',

  mounted() {
    if (!document.getElementById('webinarScript')) {
      const webinarScript = document.createElement('script');
      webinarScript.setAttribute('src', 'https://cdn.demio.com/dist/embed.bundle.js');
      webinarScript.setAttribute('id', 'webinarScript');
      document.head.appendChild(webinarScript);
    }
  },

  beforeDestroy() {
    if (document.getElementById('webinarScript')) {
      document.getElementById('webinarScript').remove();
    }
  },
};
</script>
